import React, { useState } from "react";
import theme from "../../styles/theme.json";
import InputMask from "react-input-mask"; // Para CPF e CNPJ

const InfoCliente = () => {
  const logado = false; // Define se o usuário está logado ou não

  const [formData, setFormData] = useState({
    nome: "",
    telefone: "",
    email: "",
    senha: "",
    dataNascimento: "",
    genero: "",
    documentoTipo: "CPF", // "CPF" ou "CNPJ"
    documentoNumero: "",
    cidade: "",
    uf: "",
    cep: "",
    numeroEndereco: "",
    logradouro: "",
  });

  const [isGeneroDropdownOpen, setIsGeneroDropdownOpen] = useState(false);
  const [isDocumentoDropdownOpen, setIsDocumentoDropdownOpen] = useState(false);

  const generoOptions = ["Masculino", "Feminino", "Outro"];
  const documentoOptions = ["CPF", "CNPJ"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleGeneroSelect = (option) => {
    setFormData({ ...formData, genero: option });
    setIsGeneroDropdownOpen(false);
  };

  const handleDocumentoSelect = (option) => {
    setFormData({ ...formData, documentoTipo: option, documentoNumero: "" });
    setIsDocumentoDropdownOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Dados do usuário enviados: ", formData);
  };

  return (
    <>
      {!logado && (
        <div className="user-registration">
          <h4
            style={{
              fontWeight: "700",
              marginBottom: "10px",
              color: theme.colors.dark,
            }}
          >
            Informações pessoais
          </h4>
          <form onSubmit={handleSubmit}>
            {/* Nome */}
            <div className="form-group">
              <label>Nome completo:</label>
              <input
                type="text"
                name="nome"
                value={formData.nome}
                onChange={handleInputChange}
                required
                placeholder="Digite seu nome completo"
              />
            </div>

            {/* Telefone */}
            <div className="form-group">
              <label>Telefone:</label>
              <InputMask
                mask="(99) 99999-9999"
                name="telefone"
                value={formData.telefone}
                onChange={handleInputChange}
                required
                placeholder="(XX) XXXXX-XXXX"
              />
            </div>

            {/* Email */}
            <div className="form-group">
              <label>Email:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                placeholder="seuemail@dominio.com"
              />
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default InfoCliente;
